__turbopack_context__.v({
  "enheter": "Virksomhetsvelger-module__IjyCjW__enheter",
  "friKomponent": "Virksomhetsvelger-module__IjyCjW__friKomponent",
  "innhold": "Virksomhetsvelger-module__IjyCjW__innhold",
  "popup": "Virksomhetsvelger-module__IjyCjW__popup",
  "popupHeader": "Virksomhetsvelger-module__IjyCjW__popupHeader",
  "tekst": "Virksomhetsvelger-module__IjyCjW__tekst",
  "virksomhetsnavn": "Virksomhetsvelger-module__IjyCjW__virksomhetsnavn",
  "virksomhetsvelger": "Virksomhetsvelger-module__IjyCjW__virksomhetsvelger",
});
